import React, { ReactNode } from 'react'
import './ResumenSection.css'

const ResumenSection = ({ children }: { children: ReactNode }) => {
    return (
        <div className='resumen-section__item'>{children}</div>
    )
}

export default ResumenSection